// Phase 7 stage 3 part 3 — live template-preview helpers for the Task/Agenda
// create modals. Items carry `_tpl:true` so reconcile can distinguish
// template-derived rows from user-typed ones when the toggle flips OFF.
// Extracted verbatim from src/App.tsx (B.6, extract-don't-improve).
import { resolveTemplateLabel } from "./taxonomyHelpers";

export function _buildTplItems(entries: any, code: any, baseDateStr: any) {
  if (!code || !baseDateStr) return [];
  const ent = Array.isArray(entries)
    ? entries.find((e) => e.code === code)
    : null;
  const tpl =
    ent && ent.meta && Array.isArray(ent.meta.subtasks)
      ? ent.meta.subtasks
      : null;
  if (!tpl || !tpl.length) return [];
  const base = new Date(
    typeof baseDateStr === "string" ? baseDateStr.slice(0, 10) : baseDateStr,
  );
  if (isNaN(base.getTime())) return [];
  return tpl.map((s: any, i: any) => {
    const off = Number.isFinite(Number(s.offsetDays))
      ? Number(s.offsetDays)
      : 0;
    const d = new Date(base);
    d.setUTCDate(d.getUTCDate() + off);
    // Phase 7 stage 3 correction — carry trilingual labels so the edit-mode
    // Insert button can POST textEn/Fr/Nl alongside `text`, matching what
    // the server's auto-injector writes on parent create. `s.label` is the
    // legacy single-string field for labelEn fallback.
    const _en =
      s.labelEn != null && s.labelEn !== "" ? s.labelEn : s.label || null;
    const _fr = s.labelFr != null && s.labelFr !== "" ? s.labelFr : null;
    const _nl = s.labelNl != null && s.labelNl !== "" ? s.labelNl : null;
    return {
      _localId: "tpl-" + i,
      _tpl: true,
      text: resolveTemplateLabel(s) || "Step " + (i + 1),
      textEn: _en,
      textFr: _fr,
      textNl: _nl,
      dueDate: d.toISOString().slice(0, 10),
      sortOrder: i,
      done: false,
    };
  });
}
export function _reconcileTpl(prevSubtasks: any, tplItems: any, on: any) {
  const handAdded = Array.isArray(prevSubtasks)
    ? prevSubtasks.filter((s) => !s._tpl)
    : [];
  if (!on) return handAdded.map((s, i) => ({ ...s, sortOrder: i }));
  return [
    ...tplItems.map((s: any, i: any) => ({ ...s, sortOrder: i })),
    ...handAdded.map((s, i) => ({ ...s, sortOrder: tplItems.length + i })),
  ];
}
